"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerritoryAdminPage = void 0;
const shared_1 = require("../../../../backend/features/default-classifiers/shared");
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const react_1 = __importDefault(require("react"));
const classifiers_1 = require("../../classifiers");
const storageClientFilter = [{ column: 'type', op: '=', value: 'territory' }];
function getEntityTitle(row) {
    return row.columns.name;
}
const EntityDetailsComponent = (props) => {
    var _a, _b;
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    return (react_1.default.createElement(classifiers_1.SlideoutFields, { fields: [
            { label: t('common.status'), value: t(`classifiers.statusEnum.${props.response.data.status}`) },
            { label: t('defaultClassifiers.fips'), value: (_a = props.response.data.fips) !== null && _a !== void 0 ? _a : '' },
            { label: t('defaultClassifiers.postalCode'), value: (_b = props.response.data.postalCode) !== null && _b !== void 0 ? _b : '' },
        ] }));
};
const TerritoryAdminPage = () => {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    const formConfig = (0, classifiers_1.useDefaultFormConfig)({ hideName: true });
    return (react_1.default.createElement(classifiers_1.ClassifierAdminPage, { entity: shared_1.jurisdictionEntityName, storageClientFilter: storageClientFilter, title: t('defaultClassifiers.territory'), fullTextSearchField: 'search', getEntityTitle: getEntityTitle, entityDetailsComponent: EntityDetailsComponent, hideCreate: true, partialUpdate: true, formConfig: formConfig }));
};
exports.TerritoryAdminPage = TerritoryAdminPage;
